import eq from 'shadow-fns/src/eq'
import either from 'shadow-fns/src/either'
import isEmpty from 'shadow-fns/src/isEmpty'

const isBlank = either(eq(false), isEmpty)
export default isBlank
